<template>
	<div class="type-input" :class="className">
		<div class="type-input-prefix" v-if="prefix" :style="prefixStyle">
			<slot name="prefix"></slot>
		</div>
		<input class="type-input-subject" 
			@blur="blur"
			:type="type"
			:value="value"
			:style="subjectStyle"
			:maxlength="maxlength" 
			:placeholder="placeholder"
			@keyup.enter="$emit('enter')"
			@input="$emit('input', $event.target.value)">
		<div class="type-input-suffix" v-if="suffix" :style="suffixStyle">
			<slot name="suffix"></slot>
		</div>
		<div class="type-input-clearable" v-if="clearable" @click="$emit('input', '')"></div>
	</div>
</template>

<script>
	export default {
		name: 'type-input',
		props: {
			type: {
				type: String,
				default: 'text'
			},
			size: {
				type: String, // max-title 1、 title 3、 subtitle 9、 content button input 6、 min-content 9
				default: '6',
				validator: value => [ '1', '2', '3', '4', '5', '6', '7', '8', '9' ].indexOf(String(value)) > -1
			},
			value: null,
			prefix: {
				type: Boolean,
				default: false
			},
			suffix: {
				type: Boolean,
				default: false
			},
			clearable: {
				type: Boolean,
				default: false
			},
			maxlength: {
				type: [String, Number],
				dafault: 20
			},
			placeholder: {
				type: String,
				default: 'Please enter context'
			},
			whitebackdrop: {
				type: Boolean,
				default: false
			}
		},
        methods: {
			blur(event) {
				if (navigator.userAgent.toLocaleLowerCase().includes('iphone')) {
					window.scroll(0, 0);
				}
				this.$emit('blur', event.target.value);
			}
        },
		computed: {
			className() {
				let name = `input-text text-content-${this.size}`;
				return name + (this.whitebackdrop ? ' white-backdrop' : ' other-backdrop');
			},
			prefixStyle() {
				return 'left: 5px';
			},
			suffixStyle() {
				return `right: ${this.clearable ? '25px' : '5px'};`;
			},
			subjectStyle() {
				if (this.prefix && this.suffix && this.clearable) {
					return 'width: calc(100% - 130px);padding: 9px 79px 9px 54px;';
				}
				if (this.prefix && this.suffix && !this.clearable) {
					return 'width: calc(100% - 110px);padding: 9px 54px;';
				}
				if (this.prefix && !this.suffix && !this.clearable) {
					return 'width: calc(100% - 66px);padding: 9px 10px 9px 54px;';
				}
				if (!this.prefix && this.suffix && !this.clearable) {
					return 'width: calc(100% - 66px);padding: 9px 54px 9px 10px;';
				}
				if (!this.prefix && !this.suffix && this.clearable) {
					return 'width: calc(100% - 37px);padding: 9px 25px 9px 10px;';
				}
				return 'width: calc(100% - 20px);padding: 9px 10px;';
			}
		}
	}
</script>

<style scoped lang="less">
	.type-input{
		width: 100%;
		min-height: 50px;
		margin: 0 auto;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		font-weight: 300;
		font-family: 'D-DIN', sans-serif;
	}
	.type-input-prefix, .type-input-subject, .type-input-suffix{
		font-size: inherit;
		font-weight: inherit;
		font-family: inherit;
	}
	.type-input-prefix, .type-input-suffix, .type-input-prefix::before, .type-input-suffix::before, .type-input-clearable{
		cursor: pointer;
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
	}
	.type-input-prefix::before, .type-input-suffix::before{
		content: '';
		width: 1px;
		height: 30%;
		transform: translateY(-50%) scale(0.5, 1);
	}
	.type-input-prefix, .type-input-suffix{
		width: 45px;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.type-input-prefix::before{
		right: 0;
	}
	.type-input-suffix::before{
		left: 0;
	}
	.type-input-subject{
		height: calc(100% - 20px);
		outline: none;
		border-radius: 0px;
		appearance: button;
		-moz-appearance: button; /* Firefox */
		-webkit-appearance: button; /* Safari 和 Chrome */
		&:focus{
			outline: none;
			box-shadow: inset 0 1px 1px rgba(0, 0, 0,  .075), 0 0 8px rgba(102, 175, 233, .6);
		}
		&::-webkit-input-placeholder, &::-ms-input-placeholder, &::-moz-placeholder{
			font-size: inherit;
			font-weight: inherit;
			font-family: inherit;
		}
	}
	.type-input-clearable{
		width: 24px;
		height: 24px;
		right: 1px;
	}
	.type-input-clearable::before, .type-input-clearable::after{
		content: '';
		position: absolute;
		top: 50%;
		left: 50%;
		width: 60%;
		height: 1px;
	}
	.type-input-clearable::before{
		transform: translate(-50%, -50%) rotate(135deg);
	}
	.type-input-clearable::after{
		transform: translate(-50%, -50%) rotate(45deg);
	}
	.white-backdrop{
		.type-input-prefix::before, .type-input-suffix::before{
			background-color: rgba(153, 153, 153, 0.35);
		}
		.type-input-clearable::before, .type-input-clearable::after{
			background-color: rgba(0, 0, 0, 0.75);
		}
		.type-input-prefix, .type-input-subject, .type-input-suffix{
			color: #000000;
		}
		.type-input-subject{
			background-color: rgba(255, 255, 255, 1);
			border: 1px solid rgba(136, 136, 136, 0.5);
			&::-webkit-input-placeholder{
				color: rgba(153, 153, 153, 1);
			}
			&::-ms-input-placeholder{
				color: rgba(153, 153, 153, 1);
			}
			&::-moz-placeholder{
				color: rgba(153, 153, 153, 1);
			}
		}
	}
	.other-backdrop{
		.type-input-prefix::before, .type-input-suffix::before{
			background-color: rgba(255, 255, 255, 0.35);
		}
		.type-input-clearable::before, .type-input-clearable::after{
			background-color: rgba(255, 255, 255, 0.75);
		}
		.type-input-prefix, .type-input-subject, .type-input-suffix{
			color: #FFFFFF;
		}
		.type-input-subject{
			background-color: rgba(0, 0, 0, 0.65);
			border: 1px solid rgba(255, 255, 255, 0.03);
			&::-webkit-input-placeholder{
				color: rgba(255, 255, 255, 0.8);
			}
			&::-ms-input-placeholder{
				color: rgba(255, 255, 255, 0.8);
			}
			&::-moz-placeholder{
				color: rgba(255, 255, 255, 0.8);
			}
		}
	}
</style>
